export class CampaignEmailApiModel {
    campaignEmailID: number;
    campaignID: number;
    customerNo: string;
    sent: string;
    sentToEmail: string;
    guid: string;
    emailContent: string;
    campaignTitle: string;
}